import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_380: DocMigration = {
  maxSchemaVersion: "0.0.380",
  description: "Rename FLOOR_MATERIAL and ROOF_LINEWORK_3D to FLOOR_FINISH and ROOF",
  apply(json: any) {
    for (const viewTemplateId in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[viewTemplateId];
      for (const categoryId in viewTemplate.categories) {
        if (viewTemplate.categories[categoryId] === "FLOOR_MATERIAL") {
          json.viewTemplates[viewTemplateId].categories[categoryId] = "FLOOR_FINISH";
        }
        if (viewTemplate.categories[categoryId] === "ROOF_LINEWORK_3D") {
          json.viewTemplates[viewTemplateId].categories[categoryId] = "ROOF";
        }
      }
    }
    return json;
  },
};

export default migration_0_0_380;
